import styled from "styled-components";

const CenterContent = styled.div<{ $backgroundColor?: string; $color?: string; $padding?: number }>`
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${p => p.$padding ? `${p.$padding}px` : "0"};
  color: ${p => p.$color};
  background-color: ${p => p.$backgroundColor};
`;

export default CenterContent;
